import {AplusDeviceProvide, AplusMqttDeviceProtocol} from "@hybird/device/terminal/aplus";
import {CompositeDeviceProtocol} from "@hybird/core/device/protocol";
import {config, DeviceType} from "@hybird/device/config";
import {
  BleV2DeviceProtocol,
  BleV2DeviceProtocolBeginSeal,
  BleV2DeviceProtocolOperation
} from "@hybird/device/protocol/blev2";
import {
  SerialDeviceProtocol,
  SerialDeviceProtocolBeginSeal,
  SerialDeviceProtocolOperation
} from "@hybird/device/protocol/serial";

class AplusJgV2DeviceProvide extends AplusDeviceProvide {

  _deviceProtocols = {
    2: AplusMqttDeviceProtocol,
    1: AplusBleJgV2DeviceProtocol,
    3: AplusJgV2CompositeDeviceProtocol,
    4: AplusSerialJgV2DeviceProtocol
  };

  constructor(deviceConnectProvide) {
    super(deviceConnectProvide);
  }

  isSupport(deviceInfo) {
    return DeviceType.aplusJg === deviceInfo.modelType;
  }
}

class AplusJgV2CompositeDeviceProtocol extends CompositeDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  get connectPromiseType() {
    return 2;
  }

  get deviceProtocols() {
    return {
      2: AplusMqttDeviceProtocol,
      1: AplusBleJgV2DeviceProtocol,
      4: AplusSerialJgV2DeviceProtocol
    };
  }
}

class AplusBleJgV2DeviceProtocol extends BleV2DeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusBleV2DeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusBleV2DeviceProtocolOperation(this.deviceInfo, this);
  }

  async beginSeal({option} = {}) {
    const deviceProtocolBeginSealPromise = super.beginSeal({option});
    await this._sync();
    return deviceProtocolBeginSealPromise;
  }

  async operation() {
    const operation = super.operation();
    await this._sync();
    return operation;
  }
}

class AplusBleV2DeviceProtocolBeginSeal extends BleV2DeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusBleV2DeviceProtocolOperation extends BleV2DeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }
}


class AplusSerialJgV2DeviceProtocol extends SerialDeviceProtocol {

  constructor(deviceProvide, deviceInfo, deviceProtocolOption) {
    super(deviceProvide, deviceInfo, deviceProtocolOption);
  }

  _createDeviceProtocolBeginSeal(option) {
    return new AplusSerialDeviceProtocolBeginSeal(this.deviceInfo, this, option);
  }

  _createDeviceProtocolOperation() {
    return new AplusSerialDeviceProtocolOperation(this.deviceInfo, this);
  }

  async beginSeal({option} = {}) {
    const deviceProtocolBeginSealPromise = super.beginSeal({option});
    await this._sync();
    return deviceProtocolBeginSealPromise;
  }

  async operation() {
    const operation = super.operation();
    await this._sync();
    return operation;
  }
}

class AplusSerialDeviceProtocolBeginSeal extends SerialDeviceProtocolBeginSeal {
  constructor(deviceInfo, deviceProtocol, option) {
    super(deviceInfo, deviceProtocol, option);
  }
}

class AplusSerialDeviceProtocolOperation extends SerialDeviceProtocolOperation {
  constructor(deviceInfo, deviceProtocol) {
    super(deviceInfo, deviceProtocol);
  }
}

export {AplusJgV2DeviceProvide};